import axios from "axios";

// ✅ Fetch Alumni Profile
export const fetchAlumniProfile = async () => {
  try {
    const token = localStorage.getItem("token")?.trim(); // Remove unwanted spaces
    let userId = localStorage.getItem("userId")?.trim(); // Prevent newline issues

    if (!token || !userId) {
      console.error("❌ No Token or User ID Found!");
      return null;
    }

    console.log(`📢 Fetching alumni profile for user ID: ${userId}`);

    // ✅ Debugging: Check if API URL is being correctly formed
    const apiUrl = `https://dynamic-reg-validation-service-51hl.onrender.com/api/register/user/${userId}`;
    console.log("🔗 API Request URL:", apiUrl);

    // ✅ Send request
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log("✅ Alumni Profile API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API Error: Alumni Profile Fetch Failed", error.response?.data || error.message);
    return null;
  }
};

export const updateAlumniProfile = async (formData) => {
  try {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    if (!token || !userId) {
      console.error("❌ No Token or User ID Found!");
      throw new Error("Unauthorized");
    }

    const formDataToSend = new FormData();
    
    // ✅ Append only if a new photo is uploaded
    if (formData.photo) {
      console.log("📸 Uploading new photo:", formData.photo.name);
      formDataToSend.append("photo", formData.photo);
    }

    // ✅ Append text fields
    Object.keys(formData).forEach((key) => {
      if (key !== "photo") {
        formDataToSend.append(key, formData[key]);
      }
    });

    console.log("📢 Sending update request to backend...");
    
    const response = await axios.put(
      `https://dynamic-reg-validation-service-51hl.onrender.com/api/register/update/alumni/${userId}`, 
      formDataToSend,
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    );

    console.log("✅ Alumni Profile Updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error Updating Alumni Profile:", error.response?.data || error.message);
    throw error;
  }
};
